"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HeadlineLockup;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _headlineLockup = _interopRequireDefault(require("@site/pattern-library-core/headline-lockup"));
var _actions = _interopRequireDefault(require("../actions"));
/* eslint-disable react/prop-types */
/** @module HeadlineLockup */

function HeadlineLockup({
  actionsLayout,
  ctas,
  ...rest
}) {
  return /*#__PURE__*/_react.default.createElement(_headlineLockup.default, (0, _extends2.default)({}, rest, {
    ctas: Array.isArray(ctas) ? /*#__PURE__*/_react.default.createElement(_actions.default, {
      actionsLayout: actionsLayout,
      ctas: ctas
    }) : ctas
  }));
}